import styles from '../../home-page/HomePage.module.scss';
import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import Label from '../../../constants/Label';
import { Beneficary } from '../beneficiary/Beneficiary';
import { transcationActions } from '../../../stores/_actions';
import { NoRecord } from '../norecord/norecord';
import { ListItems } from './ListItems';

function RecentTranscation(props) {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
      Refno: '',
      FromDate: '01/Jan/1950',
      ToDate: '01/Jan/2099',
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: null,
  };

  const dispatch = useDispatch();
  const location = useLocation();
  useEffect(() => {
    dispatch(transcationActions.transcationList(payload));
  }, []);

  let transcationListData;
  let status;

  useSelector((state) => {
    transcationListData = state.transcation?.data;
    status = state.transcation?.transcation;
  }, []);

  let style = styles.width49;
  style = location.pathname == '/home' ? styles.width35 : style;
  style = location.pathname == '/transfer' ? styles.width49 : style;
  style = location.pathname == '/calculator' || location.pathname == '/transcation-view' ? styles.width35 : style;
  const minHeight = location.pathname == '/transfer' ? '' : styles.minHeight;
  return (
    <div className={styles.pageRight + ` ` + style}>
      <div className={styles.itemHeight + ` ` + minHeight}>
        <h2>
          {Label.RecentTransactions.heading} <Link to="/transcation">view all</Link>
        </h2>
        {transcationListData ? <ListItems list={transcationListData} styles={styles} /> : <NoRecord status={status} />}
      </div>
      {location.pathname == '/transfer' ? '' : <Beneficary />}
    </div>
  );
}

export { RecentTranscation };
